import { BRAND } from "constants/brand";

/**
 * Fallback UI rendered by an ErrorBoundary when a page crashes.
 * Shows an RTL Arabic message with a reload action instead of a blank screen.
 *
 * @param {object} props
 * @param {boolean} [props.isFullScreen] - Fill the viewport (app-level boundary)
 *   instead of the routed page area (layout-level boundary).
 * @param {string} [props.title]
 * @param {string} [props.message]
 * @param {() => void} [props.onRetry]
 */
const PageErrorFallback = ({
    isFullScreen = false,
    title = "حدث خطأ غير متوقع",
    message = "نعتذر، حدث خطأ ما في هذه الصفحة. حاول تحديث الصفحة أو الانتقال لصفحة أخرى.",
    onRetry,
}) => (
    <div
        style={{
            minHeight: isFullScreen ? "100vh" : "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            direction: "rtl",
            textAlign: "center",
            padding: 24,
        }}
    >
        <h2>{title}</h2>
        <p>{message}</p>
        <button
            className="button"
            style={{ backgroundColor: BRAND, color: "#fff" }}
            onClick={onRetry || (() => window.location.reload())}
        >
            {onRetry ? "إعادة المحاولة" : "تحديث الصفحة"}
        </button>
    </div>
);

export default PageErrorFallback;
